// Centralized URL builder for app routes
// Keeps path construction consistent and enables reuse across components
export var Section;
(function (Section) {
    Section["Dashboard"] = "dashboard";
    Section["Campaigns"] = "campaigns";
    Section["Audience"] = "audience";
    Section["Leads"] = "leads";
    Section["Calendar"] = "calendar";
    Section["KnowledgeBase"] = "knowledge-base";
    Section["Settings"] = "settings";
    Section["Integrations"] = "integrations";
    Section["Admin"] = "admin";
})(Section || (Section = {}));
function toQueryString(query) {
    if (!query)
        return '';
    const parts = Object.entries(query)
        .filter(([, v]) => v !== undefined && v !== null && v !== '')
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`);
    return parts.length ? `?${parts.join('&')}` : '';
}
export const routes = {
    company: (companyId) => `/company/${companyId}`,
    companyWorkspace: (companyId, workspaceId) => `/company/${companyId}/workspace/${workspaceId}`,
    settingsAuthentication: (companyId) => `/company/${companyId}/settings/authentication`,
    settingsIntegrations: (companyId) => `/company/${companyId}/settings/integrations`,
    // Workspace-scoped helpers (explicit sections now routed directly, no generic section())
    scoped: (companyId, workspaceId) => {
        const base = `/company/${companyId}`;
        const wsBase = `${base}/workspace/${workspaceId}`;
        return {
            root: () => wsBase,
            dashboard: () => `${wsBase}/dashboard`,
            campaignsIndex: () => `${wsBase}/campaigns`,
            audienceIndex: () => `${wsBase}/audience`,
            knowledgeBase: () => `${wsBase}/knowledge-base`,
            settingsIndex: () => `${wsBase}/settings`,
            // Generic section router used by navigation components
            section: (section) => {
                switch (section) {
                    case Section.Dashboard:
                        return `${wsBase}/dashboard`;
                    case Section.Campaigns:
                        return `${wsBase}/campaigns`;
                    case Section.Audience:
                        return `${wsBase}/audience`;
                    case Section.Leads:
                        return `${wsBase}/leads`;
                    case Section.KnowledgeBase:
                        return `${wsBase}/knowledge-base`;
                    case Section.Settings:
                        return `${wsBase}/settings`;
                    case Section.Integrations:
                        return `${base}/settings/integrations`;
                    case Section.Admin:
                        return `${base}/settings/company`;
                    default:
                        return `${wsBase}/dashboard`;
                }
            },
            campaign: (campaignId, query) => `${wsBase}/campaign/${campaignId}${toQueryString(query)}`,
            campaignList: (campaignId, listId, query) => `${wsBase}/campaign/${campaignId}/campaign-list/${listId}${toQueryString(query)}`,
            web: (campaignId, webId, query) => `${wsBase}/campaign/${campaignId}/web/${webId}${toQueryString(query)}`,
            // (Leads tab deep-link helpers removed; construct manually: routes.scoped(...).web(campaignId, webId) + '/leads' or '/leads/companies'
            audienceDetail: (campaignId, fileImportId, query) => `${wsBase}/campaign/${campaignId}/audience/${fileImportId}${toQueryString(query)}`,
            settings: {
                authentication: () => `${base}/settings/authentication`,
                integrations: () => `${base}/settings/integrations`,
            },
        };
    },
};
